import { PatientNote, PatientNotePractitioner } from '@dreryk/egabinet-patient-frontend-api';

import { useFormController } from '@dreryk/react-common';
import {
   componentsTranslationKeys,
   ModalConfirmingExit,
   ModalMaxHeight,
   ModalWidth,
   StyledFlex,
} from '@dreryk/react-components';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

import { notesTranslationKeys } from '../../translations';

import { StyledNoteModalTextArea } from './StyledNoteModalTextArea';

export type NoteFormBean = {
   content: string;
};

type NoteModalCommonProps = {
   readonly content: PatientNote['content'];
   readonly toggleModalOpened: () => void;
   readonly onSubmit: (data: NoteFormBean) => void;
   readonly title: string;
   readonly confirmationButtonLabel: string;
   readonly exitConfirmationMessage: string;
   readonly testId: string;
   readonly author?: PatientNotePractitioner;
};

const NoteModalCommon = (props: NoteModalCommonProps): JSX.Element => {
   const { formState, handleSubmit, register } = useFormController<NoteFormBean>({
      content: props.content,
   });

   return (
      <ModalConfirmingExit
         title={props.title}
         onCancel={props.toggleModalOpened}
         animateVisibility
         width={ModalWidth.NORMAL}
         testId={props.testId}
         visible
         confirmationButtonLabel={props.confirmationButtonLabel}
         onSubmit={handleSubmit(props.onSubmit)}
         height={ModalMaxHeight.TALL}
         wrapInForm
         shouldConfirm={formState.isDirty}
         exitConfirmationTitle={componentsTranslationKeys.leaveForm}
         exitConfirmationMessage={props.exitConfirmationMessage}
      >
         <StyledFlex direction='column' gap='18px'>
            {props.author ? (
               <PractitionerSafePresenter
                  testId={'author'}
                  practitioner={props.author}
                  type={'text'}
                  withIdentification
               />
            ) : null}
            <StyledNoteModalTextArea
               placeholder={notesTranslationKeys.modal.placeholder}
               label={notesTranslationKeys.modal.label}
               controller={register('content', { maxLength: 3600 })}
               testId={'noteContent'}
               maxLength={3600}
               fillParent
               withoutRequiredMark
            />
         </StyledFlex>
      </ModalConfirmingExit>
   );
};

export { NoteModalCommon };
